import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';
import { HomePage } from '../../home/home';
import { ConfigurationPage } from "../../configuration/configuration";
import { SuperPage } from "../../auth/super/super";
import { Globals } from "../../../globals";
import { ConfigurationServices } from '../../configuration/services';
import { MultiPage } from '../../auth/multi/multi';
import { ProvidersServices } from '../../providers/services';
import { HomeTeacherPage } from '../../schools/home-teacher/home-teacher';
import { SchoolServices } from '../../schools/services';
import { BlockScreenPage } from '../block-screen/block-screen';
import { OrdersLoaderPage } from '../../orders/orders-loader/orders-loader';
import { NotificationsServices } from '../../services/notificationsServices';

/**
 * Generated class for the HeaderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-header',
  templateUrl: 'header.html',
})
export class HeaderPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public afAuth: AngularFireAuth,
    private globals: Globals,
    public configurationServices: ConfigurationServices,
    public providersServices: ProvidersServices,
    public schoolServices: SchoolServices,
    public notificationsServices: NotificationsServices) {

  }

  openHome() {
    this.navCtrl.setRoot(HomePage);
    this.globals.side_menu_config_active = '';
    this.globals.side_menu_active = 'dashboard';
    this.globals.menu_active = 'main';
    this.globals.open_side_menu = false;
    /*
    this.globals.side_menu_active = 'dashboard';
    if (this.globals.user_type == 'principal') {
      this.navCtrl.setRoot(HomePrincipalPage);
    } else if (this.globals.user_type == 'teacher') {
      if (this.schoolServices.enter_rest == true) {
        this.navCtrl.setRoot(HomePage);
      } else {
        this.navCtrl.setRoot(HomeTeacherPage);
      }
    } else {
      this.navCtrl.setRoot(HomePage);
    }*/
  }

  openConfig() {
    this.navCtrl.setRoot(ConfigurationPage);
    this.globals.open_side_menu = false;
    this.globals.menu_active = 'config';
    this.globals.side_menu_active = 'config';
  }

  openSuper() {
    this.navCtrl.push(SuperPage);
  }

  openMulti() {
    this.navCtrl.push(MultiPage);
  }

  openTeacherHome() {
    this.schoolServices.enter_rest = false;
    this.navCtrl.setRoot(HomeTeacherPage);
  }


  openOrdersRooms() {
    this.globals.side_menu_active = 'order';
    this.navCtrl.setRoot(OrdersLoaderPage);
  }

  blockscreen() {
    this.navCtrl.setRoot(BlockScreenPage, {
      type: 'orders',
    });
  }

  openCloseNotifications() {
    this.notificationsServices.openCloseNotificationsModal();
  }


  openSideMenu() {
    if (this.navCtrl.getActive().name.toLowerCase().includes('configuration')) {
      this.globals.menu_active = 'config';
    } else {
      this.globals.menu_active = 'main';
    }
    this.globals.open_side_menu = true;
  }

  closeSideMenu() {
    if (this.navCtrl.getActive().name.toLowerCase().includes('configuration')) {
      this.globals.menu_active = 'config';
    } else {
      this.globals.menu_active = 'main';
    }
    this.globals.open_side_menu = false;
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/header/header.ts